/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TaglineInputs */

const en_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year · Golf Digest #1 Iowa Instructor`)
};

const es_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesor del Año de la Iowa PGA · Instructor #1 de Iowa según Golf Digest`)
};

const de_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrer des Jahres der Iowa PGA · Golflehrer Nr. 1 in Iowa laut Golf Digest`)
};

const zh_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年度最佳教师 · Golf Digest 评选的爱荷华州 #1 教练`)
};

const ar_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم العام في Iowa PGA · المدرب رقم 1 في Iowa حسب Golf Digest`)
};

const fr_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignant de l’année de la Iowa PGA · Instructeur n° 1 de l’Iowa selon Golf Digest`)
};

const vi_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giáo viên của năm của Iowa PGA · Huấn luyện viên số 1 Iowa theo Golf Digest`)
};

const sw_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwalimu Bora wa Mwaka wa Iowa PGA · Mkufunzi #1 wa Iowa kwa mujibu wa Golf Digest`)
};

const th_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ครูแห่งปีของ Iowa PGA · ผู้ฝึกสอนอันดับ 1 ของไอโอวาจาก Golf Digest`)
};

const bs_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitelj godine Iowa PGA · Instruktor broj 1 u Iowi prema Golf Digestu`)
};

const ja_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年間最優秀教師 · Golf Digest選出 アイオワ州No.1インストラクター`)
};

const ko_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 올해의 교사 · Golf Digest 선정 Iowa #1 강사`)
};

const pt_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professor do Ano da Iowa PGA · Instrutor nº 1 de Iowa segundo a Golf Digest`)
};

const it_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insegnante dell’anno della Iowa PGA · Istruttore #1 dell’Iowa per Golf Digest`)
};

const sv_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lärare i Iowa PGA · Golf Digests #1 instruktör i Iowa`)
};

const nl_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leraar van het Jaar van de Iowa PGA · Nr. 1 golfleraar van Iowa volgens Golf Digest`)
};

const da_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets træner i Iowa PGA · Golf Digests #1 instruktør i Iowa`)
};

const nb_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lærer i Iowa PGA · Golf Digests #1 instruktør i Iowa`)
};

const fi_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n vuoden opettaja · Golf Digestin #1 golfopettaja Iowassa`)
};

const pl_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauczyciel Roku Iowa PGA · Instruktor nr 1 w Iowa według Golf Digest`)
};

const ru_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учитель года Iowa PGA · Инструктор №1 в Iowa по версии Golf Digest`)
};

const tr_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Yılın Öğretmeni · Golf Digest'e göre Iowa'nın 1 numaralı eğitmeni`)
};

const hi_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA वर्ष के सर्वश्रेष्ठ शिक्षक · Golf Digest के अनुसार Iowa के #1 प्रशिक्षक`)
};

const id_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year · Instruktur #1 Iowa versi Golf Digest`)
};

const ms_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year · Jurulatih #1 Iowa versi Golf Digest`)
};

const cs_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitel roku Iowa PGA · Golf Digest: #1 instruktor v Iowě`)
};

const el_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δάσκαλος της Χρονιάς της Iowa PGA · #1 εκπαιδευτής της Iowa κατά το Golf Digest`)
};

const he_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מורה השנה של Iowa PGA · המדריך #1 ב-Iowa לפי Golf Digest`)
};

const af_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Onderwyser van die Jaar · Golf Digest se #1 instrukteur in Iowa`)
};

const hu_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA év tanára · A Golf Digest szerint #1 oktató Iowában`)
};

/**
* | output |
* | --- |
* | "Iowa PGA Teacher of the Year · Golf Digest #1 Iowa Instructor" |
*
* @param {Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_tagline = /** @type {((inputs?: Footer_TaglineInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TaglineInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_tagline(inputs)
	if (locale === "de") return de_footer_tagline(inputs)
	if (locale === "zh") return zh_footer_tagline(inputs)
	if (locale === "ar") return ar_footer_tagline(inputs)
	if (locale === "fr") return fr_footer_tagline(inputs)
	if (locale === "vi") return vi_footer_tagline(inputs)
	if (locale === "sw") return sw_footer_tagline(inputs)
	if (locale === "th") return th_footer_tagline(inputs)
	if (locale === "bs") return bs_footer_tagline(inputs)
	if (locale === "ja") return ja_footer_tagline(inputs)
	if (locale === "ko") return ko_footer_tagline(inputs)
	if (locale === "pt") return pt_footer_tagline(inputs)
	if (locale === "it") return it_footer_tagline(inputs)
	if (locale === "sv") return sv_footer_tagline(inputs)
	if (locale === "nl") return nl_footer_tagline(inputs)
	if (locale === "da") return da_footer_tagline(inputs)
	if (locale === "nb") return nb_footer_tagline(inputs)
	if (locale === "fi") return fi_footer_tagline(inputs)
	if (locale === "pl") return pl_footer_tagline(inputs)
	if (locale === "ru") return ru_footer_tagline(inputs)
	if (locale === "tr") return tr_footer_tagline(inputs)
	if (locale === "hi") return hi_footer_tagline(inputs)
	if (locale === "id") return id_footer_tagline(inputs)
	if (locale === "ms") return ms_footer_tagline(inputs)
	if (locale === "cs") return cs_footer_tagline(inputs)
	if (locale === "el") return el_footer_tagline(inputs)
	if (locale === "he") return he_footer_tagline(inputs)
	if (locale === "af") return af_footer_tagline(inputs)
	if (locale === "hu") return hu_footer_tagline(inputs)
	return en_footer_tagline(inputs)
});